import React, { FunctionComponent, useContext } from 'react';
import { PageContext, PageContextProps } from '/src/contexts/Page';
import { User } from '/src/domain/shared/User';
import { Track } from '/src/domain/challenges/ChallengeAuditData';
import { ButtonBase, Link, SxProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { links } from '/src/domain/shared/links';

interface AppealButtonProps {
  track: Track;
  currentUser: User;
  challengeKey: string;
}

const AppealButton: FunctionComponent<AppealButtonProps> = ({
  track,
  currentUser,
  challengeKey,
}) => {
  const { t } = useTranslation();
  const { pageConfig } = useContext(PageContext) as PageContextProps;

  if (
    String(track.stravauser) !== String(currentUser.id) ||
    !currentUser.isPremium ||
    pageConfig?.isAppealDisabled
  ) {
    return null;
  }

  return (
    <Link
      href={`${links.origin}/activity?aid=${track.id}&challenge-key=${challengeKey}`}
      target="_blank"
      rel="noopener"
      sx={{ display: 'block' }}
    >
      <ButtonBase sx={appealButtonSx}>{t('appeal')}</ButtonBase>
    </Link>
  );
};

const appealButtonSx: SxProps = {
  width: '100%',
  height: '2.7rem',
  color: 'secondary.contrastText',
  fontWeight: 500,
  backgroundColor: 'secondary.main',
  borderRadius: '4px',
  boxShadow: '0 2px 7px rgb(0, 0, 0, 0.3)',
  mt: '0.75rem',
};

export default AppealButton;
